/*!
	Tabbed Form Validator
	Whitespace 2015
*/
var FormTabValidationHandler = (function($form, settings) {
	var my;

	my = {
		facebook: false,
		validator: null,

		enable: function() {
			if (($form).length < 1) {
				return;
			}

			settings = window.ob_set(settings || {}, {
				// ... my config ...
			});

			my.$form = $form;
			$('.reg-helper').text(window.TRANSLATE.wsfp_create_an_account);

			var general_setup = {
				'popup': {
					'alignment': window.WS.Form.Alignments.bottom_right
				},
				'field': {
					'popup': {
						'alignment': window.WS.Form.Alignments.bottom_right
					}
				},
				'submit': {
					'callback': settings.selectors ? my.submitHandler : ''
				}
			};

			// ws form setup
			my.validator = new window.WS.Form(my.$form, general_setup, settings.validate);

			// swap these about if we're on the reg form
			if (my.$form.prop('id') === 'frm-register-user') {
				// validate as email
				$('#email-login').on('click', function(event) {
					event.preventDefault();
					my.facebook = false;

					$(this).addClass('selected');
					$('#frm-register-user-method').prop('checked', true);
					$('#facebook-reg-login').removeClass('selected');

					$('#email-signup-message').show();
					$('#email-signup-fields').show();

					if (window.location.hash !== '#errors') {
						$('#frm-email').val('');
						$('#frm-email_confirm').val('');
						$('#frm-password').val('');
						$('#frm-password_confirm').val('');
					}
				});

				$('#facebook-reg-login').on('click', function(event) {
					event.preventDefault();
					my.facebook = true;

					$(this).addClass('selected');
					$('#frm-register-user-method').prop('checked', true);
					$('#email-login').removeClass('selected');

					$('#email-signup-message').hide();
					$('#email-signup-fields').hide();
					$('#frm-email').val('f@b.com');
					$('#frm-email_confirm').val('f@b.com');
					$('#frm-password').val('12345');
					$('#frm-password_confirm').val('12345');
				});

				$("input[name='updates_post']").change(function() {
					$addr_fields = $(".address-fields");

					if (this.value === "Yes") {
						$addr_fields.removeClass("hidden");
						my.validator.add_field("address", {
							"require": true
						});
						my.validator.add_field("postcode", {
							"require": true
						});
						my.validator.add_field("country", {
							"require": true
						});

						if ($("input[name='state']").is(":visible")) {
							my.validator.add_field("state", {
								"require": true
							});
						}
					} else {
						$addr_fields.addClass("hidden");
						my.validator.remove_field("address", {});
						$("textarea[name='address']").val("");

						my.validator.remove_field("postcode", {});
						$("input[name='postcode']").val("");

						my.validator.remove_field("country", {});
						$("#select_country option[value='']").attr("selected", true);
						$("#proxy-for-select_country span").html("Please select your country");

						my.validator.remove_field("state", {});
						$("input[name='state']").val("");
					}
				});

				window.recaptchaCallback = function(token) {
					if (token !== "") {
						$(".field.captcha p.error").addClass("v-hidden");
					}
				}

				window.recaptchaExpire = function() {
					my.validator.remove_field("g-recaptcha-response");
				}

				my.$form.bind("form:error", function(event, form, faults) {
					$(faults).each(function(index, elem) {
						if (elem["name"] === "g-recaptcha-response") {
							if ($(elem["element"][0]).val() === "") {
								$(elem["element"][0]).closest(".field.captcha").find(".error").removeClass("v-hidden");
							}
						}
					});
				});
			}

			// tabbed form
			if (settings.selectors) {
				my.tabs = my.$form.find(settings.selectors.stage);

				if (window.location.hash === '#errors') {
					my.current_tab = 1;
				} else {
					my.current_tab = 0;
				}

				// initial form validation handler
				my.formTabsSetup();
			}
		},

		formTabsSetup: function() {
			var css_class = '', str = '', tmp, width = 100 / my.tabs.length, offset = 0;

			if (my.tabs.length > 3) {
				width = 100 / 3;
			}

			// set up the tabs
			$.each(my.tabs, function(index, tab) {
				tab.is_valid = false;
				tmp = $(tab);
				tmp.hide();

				if (my.tabs.length <= 3) {
					offset = 1;
				}

				if (index < 1) {
					css_class = ' class="tab-stage-' + index + ' first active"';
				} else if (index > my.tabs.length) {
					css_class = ' class="tab-stage-' + index + ' last"';
				} else {
					css_class = ' class="tab-stage-' + index + ' first"';
				}

				str = str + '<li ' + css_class + ' style="width: ' + width + '%;">' + (index + offset) + '</li>';
			});

			// add the tab indicators

			my.$form.prepend('<ul class="form-tab-control">' + str + '</ul>');

			if (my.tabs.length > 3) {
				$('.form-tab-control li:first-child').hide();
			}

			if (my.tabs.length > 3 && my.current_tab === 0) {
				$('.form-tab-control').hide();
			} else {
				$('.form-tab-control').show();
			}

			if (window.location.hash === '#errors') {
				$($('.form-tab-control li')[1]).addClass('active');
				$('.reg-helper').text('Continue');
				$('.login-helper').hide();
				$('.form-tab-control').show();
			}

			// show the first or current tab
			$(my.tabs[my.current_tab]).show();
		},

		submitHandler: function() {
			if (!my.facebook) {
				// tab-indicator
				$('.tab-stage-' + my.current_tab).removeClass('active');

				window.setTimeout(function() {
					var $captcha_field = my.$form.find($(".g-recaptcha"));
					if ($captcha_field.length > 0 && $captcha_field.is(':visible')) {
						my.validator.add_field("g-recaptcha-response", {
							"require": true
						});

						window.recaptchaCallback = function(token) {
							if (token !== "") {
								my.$form.find(".field.captcha p.error").addClass("v-hidden");
							}
						}

						window.recaptchaExpire = function() {
							my.validator.remove_field("g-recaptcha-response");
						}

						my.$form.bind("form:error", function(event, form, faults) {
							$(faults).each(function(index, elem) {
								if (elem["name"] === "g-recaptcha-response") {
									if ($(elem["element"][0]).val() === "") {
										$(elem["element"][0]).closest(".field.captcha").find(".error").removeClass("v-hidden");
									}
								}
							});
						});
					}
				}, 500);

				// go to the next or submit
				my.current_tab = my.current_tab + 1;
				if (my.current_tab === my.tabs.length) {
					my.$form.find('button.button').addClass('loading').attr('disabled','disabled').attr('readonly','readonly');
					return true;
				}

				if (my.$form.prop('id') === 'frm-register-user') {
					if (my.current_tab > 0) {
						$('.reg-helper').text(window.TRANSLATE.wsfp_continue);
						$('.login-helper').hide();
						$('.form-tab-control').show();
					} else {
						$('.reg-helper').text(window.TRANSLATE.wsfp_create_an_account);
						$('.login-helper').show();
						$('.form-tab-control').hide();
					}
				}

				// hide all and show the current tab
				$(my.tabs).hide();
				$(settings.selectors.index).val(my.current_tab);
				$('button').blur();
				$(my.tabs[my.current_tab]).show();
				$('.tab-stage-' + my.current_tab).addClass('active');
				$('html, body').animate({
					scrollTop: my.$form.offset().top
				}, 500);
			} else {
				window.fbLogin($('#frm-project-donate-newsletter').is(':checked'), $('button#form-control'));
			}

			return false;
		}
	};

	my.enable();
});

(function() {

	if ($('#frm-forgotten-password')) {
		new FormTabValidationHandler($('#frm-forgotten-password'), {
			'validate': {
				'email': {
					'require': true,
					'type': window.WS.Form.ValueTypes.Email,
					'live': true
				}
			}
		});
	} // forgotten-password form

	if ($('#frm-login-user')) {
		new FormTabValidationHandler($('#frm-login-user'), {
			'validate': {
				'username': {
					'require': true,
					'type': window.WS.Form.ValueTypes.Email,
					'live': true
				},
				'password': {
					'require': true
				}
			}
		});
	} // login-user form

	if ($('#frm-create-project')) {
		new FormTabValidationHandler($('#frm-create-project'), {
			'selectors': {
				'index': 'input#frm-tab', // sets the tab index
				'stage': 'fieldset.step',
				'indicators': 'ul.form-tab-control'
			},
			'validate': {
				'tab': {
					'cascade': [{
						'value': '0',
						'fields': {
							'school_id': {
								'require': true
							},
							'goal_amount': {
								'require': true
							}
						}
					},{
						'value': '1',
						'fields': {
							'title': {
								'require': true
							},
							'story': {
								'require': true
							}
						}
					}]
				}
			}
		});

	} // create-project form

	if ($('#frm-register-user')) {
		new FormTabValidationHandler($('#frm-register-user'), {
			'selectors': {
				'index': 'input#frm-tab', // sets the tab index
				'stage': 'fieldset.step',
				'indicators': 'ul.form-tab-control'
			},
			'validate': {
				'tab': {
					'cascade': [{
						'value': '1',
						'fields': {
							'email': {
								'require': true,
								'type': window.WS.Form.ValueTypes.Email,
								'live': true,
								'cascade': {
									'fields': {
										'email_confirm': {
											'require': true,
											'type': window.WS.Form.ValueTypes.Email,
											'duplicate_of': 'email'
										}
									}
								}
							},
							'password': {
								'require': true,
								'cascade': {
									'fields': {
										'password_confirm': {
											'require': true,
											'duplicate_of': 'password'
										}
									}
								}
							},
							'updates_email': {
								'require': true,
								'popup': {
									'alignment': window.WS.Form.Alignments.bottom_right
								}
							},
							'updates_post': {
								'require': true,
								'popup': {
									'alignment': window.WS.Form.Alignments.bottom_right
								}
							},
							'method': {
								'require': true
							}
						}
					},{
						'value': '2',
						'fields': {
							'first_name': {
								'require': true
							},
							'last_name': {
								'require': true
							},
							'dob_d': {
								'require': true
							},
							'dob_m': {
								'require': true
							},
							'dob_y': {
								'require': true
							}
						}
					}]
				}
			},
			'validate_facebook': {
				'tab': {
					'cascade': [{
						'value': '1',
						'fields': {
							'updates_email': {
								'require': true,
								'popup': {
									'alignment': window.WS.Form.Alignments.bottom_right
								}
							},
							'updates_post': {
								'require': true,
								'popup': {
									'alignment': window.WS.Form.Alignments.bottom_right
								}
							},
							'method': {
								'require': true
							}
						}
					}]
				}
			}
		});
	} // reg form
})();
